export type TLink = {
  title?: string;
  subtitle?: string;
  url: string;
  icon?: string;
  target?: "_self" | "_blank";
  ariaLabel?: string;
  rel?: string;
};

export type TTarget = "_self" | "_blank";

export type TLinkList = {
  title?: string;
  links?: Array<TLink>;
};

export type TCategory = {
  title: string;
  mainCategoryLink?: TLink | undefined;
  links?: Array<TLink>;
};

export const isCategoryType = (obj: any): obj is TCategory => {
  if (obj.links && Array.isArray(obj.links)) {
    return true;
  }

  return false;
};
